import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";
import {
  EntrepotActivityOption,
  entrepotActivities,
} from "$utils/typeConstants";
import { Text } from "$components";
import useJStyles from "$hooks/useJStyles";

type Props = {
  values: any;
  onChange?: (value: any) => void;
};

function EntrepotActivities({ values, onChange, ...props }: Props) {
  const classes = useStyles();
  const { jclasses } = useJStyles();

  const handleToogleActivity = (
    activity: EntrepotActivityOption,
    next: (values: string[]) => void
  ) => {
    const isAlreadyPresent = !values.includes(activity.value);
    const isParent = activity.parent === "";
    let newActivities: string[] = [];

    if (isParent) {
      const withEnfant = [
        ...entrepotActivities
          .filter((a) => a.parent === activity.value)
          .map(({ value }) => value),
        activity.value,
      ];
      newActivities = isAlreadyPresent
        ? [...values, ...withEnfant]
        : values.filter((a) => !withEnfant.includes(a));
    } else {
      newActivities = isAlreadyPresent
        ? [...values, activity.value]
        : values.filter((a) => a !== activity.value);
      const includeParent = values.includes(activity.parent);
      const childActivities = entrepotActivities
        .filter((a: any) => a.parent === activity.parent)
        .map(({ value }) => value);
      if (
        !isAlreadyPresent &&
        includeParent &&
        !newActivities.find((nA) => childActivities.includes(nA))
      ) {
        // remove parent if none child is selected
        newActivities = newActivities.filter((a) => a !== activity.parent);
      } else if (
        !includeParent &&
        !childActivities.find((a) => !newActivities.includes(a))
      ) {
        newActivities = [...newActivities, activity.parent];
      }
    }

    const vals = newActivities.filter(
      (value, idx, array) => array.indexOf(value) === idx
    );
    next(vals);
  };

  const baseActivities = entrepotActivities.filter((a) => a.isAMainActivity);
  const otherActivities = entrepotActivities.filter((a) => !a.isAMainActivity);

  return (
    <>
      {baseActivities.map((a) => (
        <FormControlLabel
          key={`activity-${a.title}`}
          className={classes.subActivities}
          control={
            <Checkbox
              {...props}
              checked={values.includes(a.value)}
              onChange={() => handleToogleActivity(a, onChange)}
              name="acts"
              color="primary"
            />
          }
          label={a.title}
        />
      ))}

      <div className={classes.activitiesContainer}>
        <div className={jclasses.formSectionHead} style={{ width: "100%" }}>
          <Text type="h3">Détails des activité(s)</Text>
        </div>
        {otherActivities
          .filter(({ parent }) => parent === "")
          .map((a) => (
            <div
              key={`activity-${a.value}`}
              className={classes.activitiesGroup}
            >
              <FormControlLabel
                className={classes.activities}
                control={
                  <Checkbox
                    {...props}
                    checked={values.includes(a.value)}
                    onChange={() => handleToogleActivity(a, onChange)}
                    name="acts"
                    color="primary"
                  />
                }
                label={a.title}
              />
              <div className={classes.subActivitiesBloc}>
                {otherActivities
                  .filter(({ parent }) => parent === a.value)
                  .map((b) => {
                    return (
                      <FormControlLabel
                        key={`activity-${a.value}-${b.title}`}
                        className={classes.subActivities}
                        control={
                          <Checkbox
                            {...props}
                            checked={values.includes(b.value)}
                            onChange={() => handleToogleActivity(b, onChange)}
                            name="acts"
                            color="primary"
                          />
                        }
                        label={b.title}
                      />
                    );
                  })}
              </div>
            </div>
          ))}
      </div>
    </>
  );
}

export default EntrepotActivities;

const useStyles = createUseStyles(() => ({
  activitiesContainer: {
    display: "flex",
    flexWrap: "wrap",
    maxWidth: 555,
  },
  activitiesGroup: {
    display: "flex",
    flexDirection: "column",
    flex: "0 1 50%",
    marginBottom: 20,
    "& span": {
      fontSize: "15px",
    },
  },
  subActivitiesBloc: {
    marginTop: 3,
    paddingLeft: 10,
    borderLeft: `1px solid ${theme.color.gray3}`,
  },
  activities: {
    "& .MuiButtonBase-root": {
      padding: 7,
    },
    "& .MuiTypography-root": {
      fontWeight: "bold",
    },
  },
  subActivities: {
    composes: "$activities",
    "&.MuiFormControlLabel-root": {
      display: "block",
    },
    "&:first-child": {
      marginTop: -10,
    },
    "&:last-child": {
      marginBottom: -10,
    },
    "& .MuiTypography-root": {
      fontWeight: "normal",
    },
  },
}));
